<mat-paginator #paginator
  (page)="loadPage($event)"
  [length]="pager.total"
  [pageSize]="pager.perPage"
  [disabled]="disabled"
  [showFirstLastButtons]="showFirstLastButtons"
  [hidePageSize]="hidePageSize"
  [pageIndex]="pager.page - 1">
</mat-paginator>